(() => {
  'use strict';
  if (window.bbbSizeAlternatives) return;
  const configElement = document.getElementById('bbb-size-alternatives-data');
  const dialog = document.getElementById('bbb-size-alternatives-dialog');
  if (!configElement || !dialog || !dialog.showModal) return;
  const config = JSON.parse(configElement.textContent);
  const source = config.product;
  if (source.sizeIndex < 0) return;
  window.bbbSizeAlternatives = true;
  const norm = value => String(value || '').normalize('NFKC').toLocaleLowerCase('nb-NO').trim();
  const sizeKeys = variant => (variant.sizes || []).map(norm);
  const category = product => {
    const title = norm(product.title);
    const rules = [
      ['swim-diaper', /badebleie|swim.?diaper/],
      ['swim-bottom', /badeshorts|badebukse|swim.?short|swim.?trunk/],
      ['joggedress', /joggedress|joggesett|tracksuit|crewsuit/],
      ['vinterregndress', /vinterregndress/],
      ['regndress', /regndress/],
      ['vinterdress', /vinterdress|vinterparkdress/],
      ['parkdress', /parkdress|skalldress/],
      ['regnsett', /regnsett/],
      ['regnbukse', /regnbukse/],
      ['vinterbukse', /vinterbukse|skibukse/],
      ['skallbukse', /skallbukse/],
      ['regnjakke', /regnjakke|regnkåpe/],
      ['vinterjakke', /vinterjakke|dunjakke|pufferjakke/],
      ['skalljakke', /skalljakke/],
      ['balaklava', /balaklava|balaclava|finlandshette/],
      ['panneband', /pannebånd|panneband|headband/],
      ['solhatt', /solhatt|\bcaps\b/],
      ['lue', /\blue\b|knytelue|ullue|vinterlue|beanie|\bbonnet\b/],
      ['regnvotter', /regnvott/],
      ['votter', /vott|mittens?/],
      ['hansker', /hanske|five finger/],
      ['hals', /\bhals\b|ullhals|neck warmer/],
      ['strompebukser', /strømpebukse/],
      ['sokker', /sokker|ullsokk|socks/],
      ['toffler', /tøfl|tøff|footies|booties/],
      ['gummistovler', /gummistøvl|regnstøvl|dock boot/],
      ['vintersko', /vintersko|vinterstøvl/],
      ['sandaler', /sandal/],
      ['joggesko', /joggesko|sneaker/],
      ['pyjamas', /pyjamas|pysjamas|pysj/],
      ['body', /\bbody\b|omslagsbody|ullbody/],
      ['kjoler', /kjole/],
      ['skjort', /skjørt/],
      ['shorts', /shorts/],
      ['leggings', /legging|tights/],
      ['bukser', /bukse|jeans|\bpants\b/],
      ['t-skjorter', /t-skjorte|t shirt|t-shirt/],
      ['skjorter', /skjorte/],
      ['genser', /genser|sweatshirt|hoodie|hoody/],
      ['cardigan', /cardigan|strikkejakke|ulljakke|fleecejakke|teddyjakke/],
      ['ulldress', /ulldress/],
      ['sparkedress', /sparkedress|heldress|heldrakt|romper|jumpsuit/],
      ['undertoy', /boxer|truse|underbukse/]
    ];
    const found = rules.find(([, expression]) => expression.test(title));
    return found ? found[0] : '';
  };
  const sourceCategory = category(source);
  if (!sourceCategory) return;
  const legacySameSize = (requested, candidate, product) => {
    const wanted = sizeKeys(requested);
    const offered = sizeKeys(candidate);
    if (wanted.length && offered.length) {
      if (!wanted.every(key => offered.includes(key))) return false;
      if (wanted.some(key => key.startsWith('kivat '))) {
        return norm(product.vendor) === norm(source.vendor) &&
          JSON.stringify([...(requested.ages || [])].sort()) === JSON.stringify([...(candidate.ages || [])].sort());
      }
      if (wanted.some(key => /^(xs|s|m|l|xl|xxl|\d)$/.test(key))) {
        return norm(product.vendor) === norm(source.vendor);
      }
      return true;
    }
    return norm(product.vendor) === norm(source.vendor) &&
      norm(requested.options[source.sizeIndex]) === norm(candidate.options[product.sizeIndex]);
  };
  const clothingCategories = new Set(['swim-bottom','joggedress','vinterregndress','regndress','vinterdress','parkdress','regnsett','regnbukse','vinterbukse','skallbukse','regnjakke','vinterjakke','skalljakke','pyjamas','body','kjoler','skjort','shorts','leggings','bukser','t-skjorter','skjorter','genser','cardigan','ulldress','sparkedress','undertoy']);
  const monthHeights = new Map([[0,50],[1,56],[3,62],[6,68],[9,74],[12,80],[18,86],[24,92]]);
  const yearHeights = new Map([[0,50],[1,80],[2,92],...Array.from({length:14},(_,i)=>[i+3,98+i*6])]);
  const heights = Array.from({length:22},(_,i)=>50+i*6);
  const parseClothingSize = value => {
    const text = norm(value).replace(/[–—]/g,'-');
    const unit = /mnd|mån|month|\bmos?\b/.test(text) ? 'months' : /år|years?|\byrs?\b/.test(text) ? 'years' : /\bcm\b/.test(text) ? 'height' : '';
    const numeric = text.replace(/mnd\.?|måneder|mån|months?|mos?\b|år|years?|yrs?\b|cm/g,'').trim();
    if (!/^\d{1,3}(?:\s*[-/]\s*\d{1,3})?$/.test(numeric)) return null;
    const values = numeric.split(/[-/]/).map(Number);
    let kind = unit;
    if (!kind && values.every(n=>heights.includes(n))) kind='height';
    if (!kind && values.length===2 && values.every(n=>n>=1&&n<=16)) kind='years';
    if (!kind) return null;
    const table = kind==='months' ? monthHeights : kind==='years' ? yearHeights : new Map(heights.map(n=>[n,n]));
    if (!values.every(n=>table.has(n)) || values[0]>values[values.length-1]) return null;
    const low=table.get(values[0]), high=table.get(values[values.length-1]);
    return heights.filter(n=>n>=low&&n<=high);
  };
  const mappedSize = (variant, product) => {
    const explicit = (variant.sizes || []).map(value=>parseClothingSize(value)).filter(Boolean);
    if (explicit.length) return [...new Set(explicit.flat())].sort((a,b)=>a-b);
    return parseClothingSize(variant.options[product.sizeIndex]);
  };
  const sizeMatch = (requested, candidate, product) => {
    if (!clothingCategories.has(sourceCategory)) return legacySameSize(requested,candidate,product) ? 0 : null;
    const wanted=mappedSize(requested,source), offered=mappedSize(candidate,product);
    if (wanted && offered) {
      if (wanted.length===offered.length && wanted.every((n,i)=>n===offered[i])) return 0;
      if (wanted.every(n=>offered.includes(n))) return 1;
      if (wanted.length>1 && offered.length===1 && offered[0]===wanted[wanted.length-1]) return 2;
      return null;
    }
    return legacySameSize(requested,candidate,product) ? 0 : null;
  };
  const bestVariant = (requested, product) => product.variants
    .filter(variant=>variant.inStock)
    .map(variant=>({product,variant,matchRank:sizeMatch(requested,variant,product)}))
    .filter(result=>result.matchRank!==null)
    .sort((a,b)=>a.matchRank-b.matchRank)[0];
  const model = product => norm(product.title).split(/\s+[–—-]\s+/)[0];
  const score = product => (model(product) === model(source) ? 100 : 0) +
    (norm(product.vendor) === norm(source.vendor) ? 10 : 0);
  let candidates = [];
  let loading;
  let opener;
  let requestToken = 0;
  const grid = dialog.querySelector('.bbb-size-alternatives__grid');
  const status = dialog.querySelector('.bbb-size-alternatives__status');
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const fetchData = async (url, selector) => {
    const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(12000)});
    if (!response.ok) throw new Error('Alternatives unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = html.querySelector(selector);
    if (!data) throw new Error('Alternative data missing');
    return JSON.parse(data.textContent);
  };
  const requestedFor = input => {
    const section = input.closest('.product-section');
    const selected = [...section.querySelectorAll('[data-bbb-option-index] .kit-radio__input:checked')];
    return source.variants.find(variant =>
      norm(variant.options[source.sizeIndex]) === norm(input.value) &&
      selected.every(other => {
        const index = Number(other.closest('[data-bbb-option-index]').dataset.bbbOptionIndex) - 1;
        return index === source.sizeIndex || variant.options[index] === other.value;
      })
    );
  };
  const matches = requested => candidates.flatMap(product => {
    if (product.id === source.id || product.sizeIndex < 0 || category(product) !== sourceCategory) return [];
    const result = bestVariant(requested, product);
    return result ? [result] : [];
  }).sort((a, b) => a.matchRank - b.matchRank || score(b.product) - score(a.product));
  const selectors = () => [...document.querySelectorAll('.product-section[data-product-id="' + source.id + '"] [data-bbb-option-index="' + (source.sizeIndex + 1) + '"] .kit-radio__input')];
  const fitButton = button => {
    const label = button.parentElement.querySelector('label');
    if (!label) return;
    Object.assign(button.style, {left: label.offsetLeft + 'px', top: label.offsetTop + 'px', width: label.offsetWidth + 'px', height: label.offsetHeight + 'px'});
  };
  const tileObserver = new ResizeObserver(entries => entries.forEach(({target}) => {
    const button = target.querySelector('.bbb-size-alternative-trigger');
    if (button) fitButton(button);
  }));
  const update = () => {
    selectors().forEach(input => {
      const requested = requestedFor(input);
      const row = input.closest('.bbb-kit-variant');
      if (!row) return;
      let button = row.querySelector('.bbb-size-alternative-trigger');
      const show = requested && !requested.available && matches(requested).length > 0;
      row.classList.toggle('bbb-has-alternatives', !!show);
      if (!show) { button?.remove(); return; }
      if (button) { fitButton(button); return; }
      input.closest('.product-section').setAttribute('data-bbb-alternatives-ready', '');
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'bbb-size-alternative-trigger';
      const size = document.createElement('span');
      size.className = 'bbb-size-tile__size';
      size.textContent = input.value;
      const caption = document.createElement('span');
      caption.className = 'bbb-size-tile__caption';
      caption.textContent = config.strings.link.replace(/^Se\s+/, 'Se\n');
      button.append(size, caption);
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', dialog.id);
      button.setAttribute('aria-label', config.strings.link + ' – ' + input.value);
      row.append(button);
      fitButton(button);
      tileObserver.observe(row);
    });
  };
  const load = () => {
    if (loading) return loading;
    loading = (async () => {
      const swimCollection = sourceCategory === 'swim-bottom' ? config.collections.find(handle => /^(badetoy|badetøy|badeklaer|badeklær|badeshorts|badebukser)(-|$)/.test(handle)) : null;
      const collection = swimCollection || (config.collections.includes(sourceCategory) ? sourceCategory : 'all');
      let page = 1;
      const seen = new Set();
      while (page) {
        const url = new URL(root + 'collections/' + collection, location.origin);
        url.searchParams.set('view', 'bbb-size-alternatives');
        url.searchParams.set('page', page);
        url.searchParams.set('filter.v.availability', '1');
        if (collection === 'all' && sourceCategory !== 'swim-bottom') url.searchParams.set('filter.p.product_type', source.type);
        const data = await fetchData(url, '[data-bbb-alternative-page]');
        for (const product of data.products) {
          if (!seen.has(product.id)) { seen.add(product.id); candidates.push(product); }
        }
        update();
        page = data.next;
        const unavailable = source.variants.filter(variant => !variant.available);
        if (unavailable.every(variant => matches(variant).filter(result => result.matchRank === 0).length >= 4)) break;
        if (page > 20) break;
      }
    })().catch(() => { loading = null; });
    return loading;
  };
  const textElement = (className, text) => {
    const node = document.createElement('span');
    node.className = className;
    node.textContent = text;
    return node;
  };
  const card = ({product, variant, matchRank}) => {
    const link = document.createElement('a');
    link.className = 'bbb-size-alternatives__card';
    const url = new URL(product.url, location.origin);
    url.searchParams.set('variant', variant.id);
    link.href = url.href;
    if (variant.image || product.image) {
      const image = document.createElement('img');
      image.src = variant.image || product.image;
      image.alt = product.title;
      image.width = 480;
      image.height = 480;
      image.loading = 'lazy';
      link.append(image);
    }
    const body = document.createElement('div');
    body.className = 'bbb-size-alternatives__body';
    body.append(textElement('bbb-size-alternatives__name', product.title));
    body.append(textElement('bbb-size-alternatives__price', variant.price));
    body.append(textElement('bbb-size-alternatives__stock', config.strings.stock + ' · ' + variant.options[product.sizeIndex]));
    if (matchRank === 2) body.append(textElement('bbb-size-alternatives__stock', config.strings.larger));
    body.append(textElement('bbb-size-alternatives__view', config.strings.view));
    link.append(body);
    return link;
  };
  const open = async (requested, button) => {
    const token = ++requestToken;
    opener = button;
    dialog.querySelector('h2').textContent = config.strings.title + ' ' + requested.options[source.sizeIndex];
    grid.replaceChildren();
    status.textContent = config.strings.loading;
    dialog.showModal();
    document.documentElement.classList.add('bbb-alternatives-open');
    const results = [];
    let failed = false;
    const suggestions = matches(requested).slice(0, 12);
    for (let start = 0; start < suggestions.length && results.length < 4; start += 4) {
      const fresh = await Promise.allSettled(suggestions.slice(start, start + 4).map(async ({product}) => {
        const url = new URL(product.url, location.origin);
        url.searchParams.set('view', 'bbb-size-alternative');
        const updated = await fetchData(url, '[data-bbb-alternative-product]');
        const index = candidates.findIndex(item => item.id === updated.id);
        if (index >= 0) candidates[index] = updated;
        if (category(updated) !== sourceCategory) return null;
        return bestVariant(requested, updated) || null;
      }));
      if (token !== requestToken || !dialog.open) return;
      for (const result of fresh) {
        if (result.status === 'fulfilled' && result.value) results.push(result.value);
        if (result.status === 'rejected') failed = true;
      }
    }
    update();
    if (token !== requestToken || !dialog.open) return;
    results.sort((a,b)=>a.matchRank-b.matchRank || score(b.product)-score(a.product));
    grid.replaceChildren(...results.slice(0, 4).map(card));
    status.textContent = results.length ? '' : failed ? config.strings.error : config.strings.empty;
  };
  // Delegate from the document: theme/app redraws may replace variant tiles.
  document.addEventListener('click', event => {
    const button = event.target.closest('.bbb-size-alternative-trigger');
    if (!button) return;
    const input = button.closest('.bbb-kit-variant')?.querySelector('.kit-radio__input');
    if (!input || input.closest('.product-section')?.dataset.productId !== String(source.id)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const requested = requestedFor(input);
    if (requested && !requested.available) open(requested, button);
  }, true);
  const close = () => dialog.close();
  dialog.querySelector('[data-bbb-alternatives-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
  });
  dialog.addEventListener('close', () => {
    requestToken++;
    document.documentElement.classList.remove('bbb-alternatives-open');
    if (opener?.isConnected) opener.focus();
    else selectors()[0]?.closest('fieldset')?.querySelector('input:checked')?.focus();
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-bbb-option-index] .kit-radio__input')) { update(); load(); }
  });
  document.addEventListener('shopify:product:select', event => {
    if (event.target.dataset.productId !== String(source.id)) return;
    Promise.resolve(event.promise).then(() => requestAnimationFrame(update)).catch(() => {});
  });
  document.addEventListener('shopify:section:load', update);
  const section = document.querySelector('.product-section[data-product-id="' + source.id + '"]');
  if (section && source.variants.some(variant => !variant.available)) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
    }, {rootMargin: '150px'});
    observer.observe(section);
  }
})();

